import { Controller } from "stimulus"
import _ from 'lodash';

const STICKY_ELEMENT_CLASS = '.sticky-element';

class PageNavController extends Controller {
  static targets = [
    'anchorContainer'
  ]

  connect() {
    const anchorTargets = this.__getAllAnchorTargetsOnPage();
    this.__setAllAnchorTargetsTopOnPage(anchorTargets)
    anchorTargets.forEach(anchorTarget => {
      const anchorElement = this.__createAnchor(anchorTarget);
      this.anchorContainerTarget.appendChild(anchorElement);
    });
    window.addEventListener('resize', _.debounce(() => this.__setAllAnchorTargetsTopOnPage(anchorTargets), 500));
  }

  __getAllAnchorTargetsOnPage() {
    return document.querySelectorAll('[data-anchor-text]');
  }

  __setAllAnchorTargetsTopOnPage(anchorTargets) {
    anchorTargets.forEach(anchorTarget => {
      if (anchorTarget.getAttribute('data-dynamic-top') !== null) {
        anchorTarget.style.top = `-${this.__getExistingStickyElementHeight()}px`;
      }
    });
  }

  __createAnchor(anchorTarget) {
    const anchorText = anchorTarget.getAttribute('data-anchor-text');
    const id = anchorTarget.id;
    const anchorButton = document.createElement('a');
    anchorButton.classList.add('m-page-header-inpage-nav-item');
    anchorButton.href = `#${id}`;
    anchorButton.setAttribute('data-scroll-effects-target', 'anchor');
    const anchorButtonText = document.createElement('span');
    anchorButtonText.innerText = anchorText;
    const anchorBottomBar = document.createElement('span');
    anchorBottomBar.classList.add('m-page-header-inpage-nav-bottom-bar');
    anchorBottomBar.style.height = '2px';
    anchorButton.appendChild(anchorButtonText);
    anchorButton.appendChild(anchorBottomBar);
    return anchorButton;
  }

  __getExistingStickyElementHeight() {
    const navs = document.querySelectorAll(STICKY_ELEMENT_CLASS);
    let totalOffsetHeight = 0;
    navs.forEach(e => {
      const elementPositionProperty = getComputedStyle(e)['position'];
      if (e.offsetParent != null && elementPositionProperty == 'sticky') {
        const { height } = e.getBoundingClientRect();
        totalOffsetHeight += height;
      }
    });

    return totalOffsetHeight;
  }
}

export default PageNavController;
